import React, { useContext, useEffect, useRef, useState } from 'react';
import AppContext from '../../../Context/AppContext';
import configData from '../../../config';
import iconUser from '../../../Assets/img/userIcon.jpg';
import './UserMenu.css';

function BellIcon() {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
        >
            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
            <path d="M10.3 21a1.9 1.9 0 0 0 3.4 0" />
        </svg>
    );
}

function ChevronIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
        >
            <path d="M6 9l6 6 6-6" />
        </svg>
    );
}

/**
 * Header user cluster matching the V2 mock:
 * bell + profile photo + name + dropdown chevron.
 * Photo/name come from Customer/GetCustomerProfileInfo (same as original dashboard).
 */
const UserMenu = ({ profile, avatarBust, onOpenProfile }) => {
    const { logOut, checkUserSession, setNewData } = useContext(AppContext);
    const session = checkUserSession();
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const firstName = profile?.firstName || session?.firstName || '';
    const lastName = profile?.lastName || session?.lastName || '';
    const fullName =
        [firstName, lastName].filter(Boolean).join(' ') || 'Account';

    const cacheKey = avatarBust || profile?.pictureFileName || Date.now();
    const apiBase = String(configData.SERVER_URL || '').replace(/\/?$/, '/');
    const isLocalApi = /localhost|127\.0\.0\.1/i.test(apiBase);
    const avatarSrc = profile?.pictureFileName
        ? isLocalApi
            ? `/media/profile/${profile.pictureFileName}?${cacheKey}`
            : `${String(configData.SERVER_URL_IMG || '').replace(/\/?$/, '/')}` +
              `media/profile/${profile.pictureFileName}?${cacheKey}`
        : iconUser;

    const isActiveCoach =
        Boolean(profile?.isActiveCoach) ||
        localStorage.getItem('isActiveCoach') === 'true';

    useEffect(() => {
        if (!open) return undefined;
        const onDocClick = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [open]);

    const openProfile = () => {
        setOpen(false);
        if (typeof onOpenProfile === 'function') onOpenProfile();
    };

    const openDirectoryListing = () => {
        setOpen(false);
        if (typeof setNewData === 'function') {
            setNewData({
                ProfileCoach: { modalDirectiryListingShow: true },
            });
        }
    };

    return (
        <div className="dv2-user" ref={rootRef}>
            <button
                type="button"
                className="dv2-user__bell"
                aria-label="Notifications"
                title="Notifications"
            >
                <BellIcon />
                <span className="dv2-user__bell-dot" aria-hidden />
            </button>

            <button
                type="button"
                className="dv2-user__menu-btn"
                aria-haspopup="menu"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <img
                    className="dv2-user__avatar"
                    src={avatarSrc}
                    alt=""
                    onError={(e) => {
                        e.currentTarget.src = iconUser;
                    }}
                />
                <span className="dv2-user__name">{fullName}</span>
                <span className="dv2-user__chev">
                    <ChevronIcon />
                </span>
            </button>

            {open && (
                <div className="dv2-user__dropdown" role="menu">
                    {isActiveCoach ? (
                        <button
                            type="button"
                            className="dv2-user__dropdown-item"
                            role="menuitem"
                            onClick={openDirectoryListing}
                        >
                            Directory listing
                        </button>
                    ) : null}
                    <a
                        className="dv2-user__dropdown-item"
                        role="menuitem"
                        href="https://oolalife.com"
                    >
                        Oola homepage
                    </a>
                    <a
                        className="dv2-user__dropdown-item"
                        role="menuitem"
                        href={configData.FINDACOACHLINK}
                    >
                        Find a coach
                    </a>
                    <a
                        className="dv2-user__dropdown-item"
                        role="menuitem"
                        href="https://www.facebook.com/OolaLife/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Community
                    </a>
                    <button
                        type="button"
                        className="dv2-user__dropdown-item"
                        role="menuitem"
                        onClick={openProfile}
                    >
                        Profile
                    </button>
                    <button
                        type="button"
                        className="dv2-user__dropdown-item dv2-user__dropdown-item--danger"
                        role="menuitem"
                        onClick={() => {
                            setOpen(false);
                            logOut();
                        }}
                    >
                        Log out
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
